<template>
<v-container fluid>
	<v-row class="text-center">
		<v-col cols="12">
			<v-img
				:src="require('@/assets/images/icon.png')"
				contain
				height="100"
			/>
		</v-col>
		<v-col cols="12">
			<h2 class="display-1 font-weight-bold mb-3 ">FORMULARIO<v-spacer> </v-spacer> DE REGISTRO</h2>

		</v-col>
	</v-row>
	<v-row >
		<v-container>
			<v-form ref="signUpForm" v-model="formValidity">
				<v-row justify="center" align="start">
					<v-col cols="12" sm="4">

						<h4 class="secondary--text"><b>DATOS ESTABLECIMIENTO</b></h4>
						<v-text-field
							color="accent"
							v-model="business.name"
							label="Nombre Establecimiento"
							:rules="textRules"
							dense />
						<v-textarea
							color="accent"
							v-model="business.address"
							label="Dirección completa"
							:rules="textRules"
							:value="business.address"
							rows="2"/>
						<v-text-field
							color="accent"
							v-model="customer.name"
							label="Nombre fiscal"
							:rules="textRules"
							dense	/>
						<v-text-field
							color="accent"
							v-model="customer.phone"
							label="Teléfono responsable"
							:rules="textRules"
							dense	/>
						<v-text-field
							color="accent"
							v-model="business.phone"
							label="Teléfono pedidos/reservas"
							:rules="textRules"
							dense />
							<v-spacer> </v-spacer>
							<h4 class="secondary--text" > <b>DATOS ACCESO</b></h4>
						<v-text-field
							color="accent"
							v-model="customer.email"
							:rules="emailRules"
							label="E-mail"
							dense />
						<v-text-field
							color="accent"
							v-model="pass1"
							:rules="passwordRules"
							label="Contraseña"
							:type="showPass1 ? 'text' : 'password'"
							:append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="showPass1 = !showPass1"
							dense />
						<v-text-field
							color="accent"
							v-model="pass2"
							:rules="[(pass1 === pass2) || 'Contraseñas no coinciden']"
							label="Confirmar Contraseña"
							:type="showPass2 ? 'text' : 'password'"
							:append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="showPass2 = !showPass2"
							dense />


						<!-- <v-btn color="admin-accent" @click="$refs.boton1.click()"><v-icon left>mdi-camera</v-icon> Añadir Foto</v-btn>
						<input type="file" ref="boton1" class="d-none" @change="uploadPhoto($event,'photo')">
						<v-img
							:src="(photo === '') ? notPhoto : photo"
							gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
							max-width="255"
							max-height="80"
						/> -->

					</v-col>
				</v-row>
				<v-row justify="center">
					<v-col cols="12" class="text-center">
						<p>
								<v-btn
									:loading="loading"
									x-large
									color="success"
									class="ma-2 white--text"
									@click.stop="createAccount"
									:disabled="!formValidity">CREAR CUENTA </v-btn>
						</p>

						<p class="secondary--text">10 días de prueba sin compromiso</p>

						<v-btn  color="info" dark class="ma-2" text @click.stop="resetForm">RESET FORM</v-btn>
						<v-btn  color="info" dark class="ma-2" text to="/">IR AL LOGIN</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-container>

	</v-row>


</v-container>
</template>

<script>

	import { db, storage } from '@/main';
	import {mapState, mapActions, mapGetters } from 'vuex';
	import moment from 'moment'
	export default {
		name: 'register',
		data: () => ({
			loading: false,
			formValidity: false,
			customer: {
				id: null,
				user_uid: '',
				name: '',
				email: '',
				phone: '',
				address: '',
				role: 'customer',
				active: true,
				notes: "",
			},
			business: {
				id: null,
				active: true,
				homeimageheader: true,
				footer: true,
				template: true,
				address: '',
				customer_id: '',
				customer_name: '',
				facebook: '',
				instagram: '',
				name: '',
				subtitle:'',
				phone: '',
				photo_name: '',
				photo_url: '',
				twitter: '',
			},
			showPass1: false,
			showPass2: false,
			pass1: '',
			pass2: '',
			photo: '',
			uploaded: false,
			notPhoto: '/static/images/not-logo.jpg',
			emailRules: [
				value => !!value || 'El correo electrónico es obligatorio.',
				value => value.indexOf('@') !== 0 || 'El correo electrónico debe tener un nombre de usuario',
				value => value.includes('@') || 'El correo electrónico debe incluir el símbolo @',
				value => value.indexOf('.') - value.indexOf('@') > 1 || 'El correo electrónico debe contener un nombre de dominio válido',
				value => value.indexOf('.') <= value.length - 3 || 'El correo electrónico debe contener una extensión de dominio válido'
			],
			passwordRules: [
				value => value.length >= 6 || 'Contraseña obligatoria',
				value => !!value || 'Contraseña obligatoria',
			],
			photoRules: [
				value => !value || value.size < 1000000 || 'La foto debe tener menos de 1 MB!',
			],
			textRules: [v => !!v || "Este dato es obligatoria"],

		}),
		methods: {
			...mapActions('authModule',['registerUser','loginUser','checkUser','logOut']),
			...mapActions('userModule',['getUser']),
			resetForm() {
				this.$refs.signUpForm.reset()
			},
			resetValidation() {
				this.$refs.signUpForm.resetValidation()
			},
			validateForm() {
				this.$refs.signUpForm.validate()
			},
			async createAccount(){
				this.loading = true;
				// Crear ID para customer
				this.customer.id = Math.floor(Date.now() / 1000).toString();
				this.customer.created_at = Math.floor(Date.now() / 1000).toString();

				// Asignar ID y name de customer en Business
				this.business.customer_id = this.customer.id
				this.business.customer_name = this.customer.name
				// generar ID del business
				this.business.id = Math.floor(Date.now() / 1000).toString();
				this.business.registration_date = Math.floor(Date.now() / 1000).toString();
				this.business.expiration_date = moment().add(10, 'days').format('x').toString();

				this.registerUser({email: this.customer.email, password: this.pass1})
					.then(res=>{
						this.loginUser({email: this.customer.email, pass: this.pass1})
							.then(data =>{
								this.customer.user_uid = res.user.uid;
								this.$store.commit('userModule/SET_USER', this.customer, { root: true })
								db.collection('customers').doc(this.customer.id).set(this.customer);
								db.collection('bussiness').doc(this.business.id).set(this.business);
								this.loading = false;
								this.$router.push({ path: "/clientes" })

							})
						.catch((e)=>{
							console.log(e.message);
							this.loading = false;
						})
					})
					.catch(err=>{
						console.log(err.message);
						this.loading = false;
					})




			}

		}, //.methods
		computed:{
			...mapState(['loaded' ]),
			...mapGetters('userModule',['role','currentUser']),
		}
	}
</script>